module.exports = __webpack_public_path__ + "img/2.71d1cc3f.png";